import { Box, Divider } from '@chakra-ui/react';
import { useState } from 'react';

import Button from '../../../../../components/ui/buttons/Button';
import { DealWithFarthestState } from '../../../utils';
import LeaseEndDocs from '../../documents/LeaseEndDocs';
import DocumentsCardShell from '../DocumentsCardShell';
import type { UploadingTarget } from '../StepperDocumentsCard';
import UploadHistorySection from '../UploadHistorySection';

type Props = {
  deal: DealWithFarthestState;
  onUpload: (target: UploadingTarget) => void;
};

const PostSigningDocumentsCard = ({ deal, onUpload }: Props) => {
  const [signedDocsOpen, setSignedDocsOpen] = useState(false);
  const isCobuyer = !!deal?.isCobuyer;

  return (
    <DocumentsCardShell subcopy="Your signed documents and uploads">
      <LeaseEndDocs
        deal={deal}
        documentsSections={{ sectionOneOpen: signedDocsOpen, sectionTwoOpen: false }}
        setDocumentsSections={(sections) => setSignedDocsOpen(sections.sectionOneOpen)}
      />
      <Box>
        <UploadHistorySection />
        <Divider mt={4} mb={2} bgColor="grayDarkBackground" />
      </Box>
      <Button
        variant="link"
        type="button"
        size="sm"
        onClick={() => onUpload({ isCobuyer })}
        display="block"
        mx="auto"
      >
        UPLOAD DOCUMENTS
      </Button>
    </DocumentsCardShell>
  );
};

export default PostSigningDocumentsCard;
